const adminEmail = () => {
  if (process.env.NODE_ENV === "development") {
    return "mahesh.samudra@worksimply.com,mahesh@ensodigital.ca";
  }
  return "hello@worksimply.com,jaime.aoyagi@worksimply.com";
};

export default adminEmail;
